import React from "react"

const ResponsiveImage = ({ fluid, alt, objectFit = "cover", style = {} }) => {
  if (!fluid) {
    return null
  }

  const { aspectRatio = 1, src, srcSet, sizes } = fluid
  if (!src) {
    return null
  }

  // Calculate the padding-bottom percentage to maintain aspect ratio
  const paddingBottom = `${(1 / aspectRatio) * 100}%`

  return (
    <div
      className="gatsby-image-wrapper"
      style={{
        position: "relative",
        overflow: "hidden",
        height: "100%",
        width: "100%",
      }}
    >
      {/* Placeholder div to maintain aspect ratio */}
      <div aria-hidden="true" style={{ width: "100%", paddingBottom }}></div>

      {/* Picture element with different sources */}
      <picture>
        <source srcSet={srcSet} sizes={sizes} />
        <img
          sizes={sizes}
          srcSet={srcSet}
          src={src}
          alt={alt} // Use the provided alt text
          loading="lazy"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit, // Apply the objectFit prop
            objectPosition: "50% 50%",
            ...style, // Merge in any additional styles passed via the style prop
          }}
        />
      </picture>

      {/* Noscript fallback for cases where JavaScript is disabled */}
      <noscript>
        <picture>
          <source srcSet={srcSet} sizes={sizes} />
          <img
            loading="lazy"
            sizes={sizes}
            srcSet={srcSet}
            src={src}
            alt={alt} // Use the alt text here too
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              opacity: 1,
              width: "100%",
              height: "100%",
              objectFit, // Apply the objectFit prop
              objectPosition: "center",
              ...style, // Merge in any additional styles passed via the style prop
            }}
          />
        </picture>
      </noscript>
    </div>
  )
}

export default ResponsiveImage
